import * as actionTypes from './actionTypes';

/**
 * Stores the last executed search request for a given search type so that it can be
 * replayed when the agent navigates back to that search tab.
 */
export const setPersistedSearchRequest = (searchType, request) => {
    return {
        type: actionTypes.SET_PERSISTED_SEARCH_REQUEST,
        searchType: searchType,
        request: request
    }
}

export const clearPersistedSearchRequest = (searchType) => {
    return {
        type: actionTypes.CLEAR_PERSISTED_SEARCH_REQUEST,
        searchType: searchType
    }
}

export const clearAllPersistedSearchRequests = () => {
    return {
        type: actionTypes.CLEAR_ALL_PERSISTED_SEARCH_REQUESTS
    }
}

export const getPersistedSearchRequest = (state, searchType) => {
    return state && state.persistedSearch && state.persistedSearch.requests
        ? state.persistedSearch.requests[searchType] || null
        : null;
}
